import { createApp } from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { abilitiesPlugin } from '@casl/vue'
import { PureAbility } from '@casl/ability'

import {
  faEnvelope,
  faArrowUpRight,
  faArrowUpRightFromSquare,
  faPencil,
  faDashboard,
  faCreditCard,
  faFileInvoiceDollar,
  faMapLocation,
  faChevronDown,
  faChevronUp,
  faInfoCircle,
  faCircleCheck,
  faFolderOpen,
  faTruck,
  faBookOpen,
  faEyeSlash,
  faCheck,
  faUser,
  faTrash,
  faDownload,
  faLink,
  faPlus,
  faPlusLarge,
  faList,
  faRepeat,
  faPiggyBank,
  faBuilding,
  faBoxArchive,
  faEllipsisV,
  faArrowUpToLine,
  faComment,
  faLocationDot,
  faUsers,
  faAddressCard,
  faNote,
  faHouseChimneyMedical,
  faCrateApple,
  faArrowLeft,
  faDolly,
  faStarHalfAlt,
  faStar,
  faBoxOpen,
  faExclamationTriangle,
  faGear,
  faBullhorn,
  faEdit,
  faAdd,
  faExclamationCircle,
  faShelves,
  faWrench,
  faBalloon,
  faCoffee,
  faStore,
  faUtensils,
  faHandshake,
  faRecycle,
  faRecordVinyl,
  faCloudArrowUp,
  faCirclePlus,
  faEye,
  faRotate,
  faAward,
  faClose,
  faArchive,
  faHatCowboy,
  faAppleCore,
  faChartPieSimpleCircleDollar,
  faArrowRight,
  faArrowTrendUp,
  faArrowTrendDown,
  faArrowAltToBottom,
  faHorizontalRule,
  faImage,
  faSpinner,
  faArrowDownToLine,
  faMap,
  faMapPin,
  faHashtag,
  faCashRegister,
  faIslandTropical,
  faLoader,
  faBroomWide,
  faPenToSquare,
  faBasketShopping,
  faMessageDots,
  faRightToBracket,
  faReceipt,
  faCircleQuestion,
  faShop,
  faClock,
  faGrid,
  faChevronLeft,
  faChevronRight,
  faX,
  faMinus,
  faCircleExclamation,
  faRobot,
  faMapLocationDot,
  faAngleDown,
  faSwap,
  faFaceSmile,
  faFaceSmileWink,
  faFaceLaugh,
  faFaceFrown,
  faFire,
  faCalendarStar,
  faCalendarDay,
  faEmptySet,
  faHourglassHalf,
  faSearch,
  faWheatSlash,
  faLeaf,
  faDropletSlash,
  faPeanuts,
  faWineBottle,
  faCircleK,
  faCarrot,
  faArrowUp,
  faArrowDown,
  faCalendarWeek,
  faCalendarCircleExclamation,
  faCalendarCirclePlus,
  faSquareQuestion,
  faMoon,
  faShoppingCart,
  faSliders,
  faCartShoppingFast,
  faCircleMinus,
  faSparkles,
  faPaperPlane,
  faPaperPlaneTop,
  faFilter,
  faPause,
  faStarExclamation,
  faRotateLeft,
  faStarShooting,
  faMessageSmile,
  faPlay,
  faSort,
  faGalleryThumbnails,
  faHome,
  faDoNotEnter,
  faTag,
  faAppleWhole,
  faChartBar,
  faCircleDollar,
  faFileInvoice,
  faClipboardCheck,
  faCalendar,
  faSignOutAlt,
  faSignInAlt,
  faBars,
}
  from '@fortawesome/pro-solid-svg-icons'

import {
  faEnvelope as farEnvelope,
  faPencil as farPencil,
  faArrowUpRight as farArrowUpRight,
  faArrowUpRightFromSquare as farArrowUpRightFromSquare,
  faArrowAltToBottom as farArrowAltToBottom,
  faDashboard as farDashboard,
  faCreditCard as farCreditCard,
  faFileInvoiceDollar as farFileInvoiceDollar,
  faMapLocation as farMapLocation,
  faChevronDown as farChevronDown,
  faChevronUp as farChevronUp,
  faInfoCircle as farInfoCircle,
  faCircleCheck as farCircleCheck,
  faFolderOpen as farFolderOpen,
  faTruck as farTruck,
  faBookOpen as farBookOpen,
  faEyeSlash as farEyeSlash,
  faCheck as farCheck,
  faUser as farUser,
  faTrash as farTrash,
  faDownload as farDownload,
  faLink as farLink,
  faPlus as farPlus,
  faPlusLarge as farPlusLarge,
  faList as farList,
  faRepeat as farRepeat,
  faPiggyBank as farPiggyBank,
  faBuilding as farBuilding,
  faBoxArchive as farBoxArchive,
  faEllipsisV as farEllipsisV,
  faArrowUpToLine as farArrowUpToLine,
  faComment as farComment,
  faLocationDot as farLocationDot,
  faUsers as farUsers,
  faAddressCard as farAddressCard,
  faNote as farNote,
  faHouseChimneyMedical as farHouseChimneyMedical,
  faCrateApple as farCrateApple,
  faArrowLeft as farArrowLeft,
  faDolly as farDolly,
  faStarHalfAlt as farStarHalfAlt,
  faStar as farStar,
  faSliders as farSliders,
  faBoxOpen as farBoxOpen,
  faExclamationTriangle as farExclamationTriangle,
  faGear as farGear,
  faBullhorn as farBullhorn,
  faCircleXmark as farCircleXmark,
  faEdit as farEdit,
  faAdd as farAdd,
  faExclamationCircle as farExclamationCircle,
  faShelves as farShelves,
  faWrench as farWrench,
  faBalloon as farBalloon,
  faCoffee as farCoffee,
  faStore as farStore,
  faUtensils as farUtensils,
  faHandshake as farHandshake,
  faRecycle as farRecycle,
  faRecordVinyl as farRecordVinyl,
  faCloudArrowUp as farCloudArrowUp,
  faCirclePlus as farCirclePlus,
  faEye as farEye,
  faRotate as farRotate,
  faAward as farAward,
  faClose as farClose,
  faArchive as farArchive,
  faHatCowboy as farHatCowboy,
  faChartPieSimpleCircleDollar as farChartPieSimpleCircleDollar,
  faArrowRight as farArrowRight,
  faArrowTrendUp as farArrowTrendUp,
  faArrowTrendDown as farArrowTrendDown,
  faHorizontalRule as farHorizontalRule,
  faImage as farImage,
  faSpinner as farSpinner,
  faArrowDownToLine as farArrowDownToLine,
  faMap as farMap,
  faBroomWide as farBroomWide,
  faPenToSquare as farPenToSquare,
  faBasketShopping as farBasketShopping,
  faMessageDots as farMessageDots,
  faRightToBracket as farRightToBracket,
  faMapPin as farMapPin,
  faHashtag as farHashtag,
  faCashRegister as farCashRegister,
  faCircleQuestion as farCircleQuestion,
  faShop as farShop,
  faReceipt as farReceipt,
  faGrid as farGrid,
  faChevronLeft as farChevronLeft,
  faChevronRight as farChevronRight,
  faX as farX,
  faLoader as farLoader,
  faMinus as farMinus,
  faCircleExclamation as farCircleExclamation,
  faRobot as farRobot,
  faMapLocationDot as farMapLocationDot,
  faAngleDown as farAngleDown,
  faClock as farClock,
  faSwap as farSwap,
  faFaceSmile as farFaceSmile,
  faFaceSmileWink as farFaceSmileWink,
  faFaceLaugh as farFaceLaugh,
  faFaceFrown as farFaceFrown,
  faCalendarStar as farCalendarStar,
  faCalendarDay as farCalendarDay,
  faEmptySet as farEmptySet,
  faHourglassHalf as farHourglassHalf,
  faSearch as farSearch,
  faWheatSlash as farWheatSlash,
  faLeaf as farLeaf,
  faDropletSlash as farDropletSlash,
  faPeanuts as farPeanuts,
  faWineBottle as farWineBottle,
  faCircleK as farCircleK,
  faCarrot as farCarrot,
  faArrowUp as farArrowUp,
  faArrowDown as farArrowDown,
  faCalendarWeek as farCalendarWeek,
  faCalendarCircleExclamation as farCalendarCircleExclamation,
  faCalendarCirclePlus as farCalendarCirclePlus,
  faSquareQuestion as farSquareQuestion,
  faMoon as farMoon,
  faCommentPen as farCommentPen,
  faShoppingCart as farShoppingCart,
  faCartShoppingFast as farCartShoppingFast,
  faCircleMinus as farCircleMinus,
  faSparkles as farSparkles,
  faPaperPlane as farPaperPlane,
  faPaperPlaneTop as farPaperPlaneTop,
  faFileLines as farFileLines,
  faFileExport as farFileExport,
  faFilter as farFilter,
  faPause as farPause,
  faStarExclamation as farStarExclamation,
  faRotateLeft as farRotateLeft,
  faDollar as farDollar,
  faAppleWhole as farAppleWhole,
  faCrown as farCrown,
  faCookie as farCookie,
  faSnowflake as farSnowflake,
  faFlowerTulip as farFlowerTulip,
  faSun as farSun,
  faLeafMaple as farLeafMaple,
  faMessageSmile as farMessageSmile,
  faClockRotateLeft as farClockRotateLeft,
  faHome as farHome,
  faDoNotEnter as farDoNotEnter,
  faGalleryThumbnails as farGalleryThumbnails,
  faTag as farTag,
  faChartBar as farChartBar,
  faCircleDollar as farCircleDollar,
  faFileInvoice as farFileInvoice,
  faClipboardCheck as farClipboardCheck,
  faCalendar as farCalendar,
  faSignOutAlt as farSignOutAlt,
  faSignInAlt as farSignInAlt,
  faBars as farBars,
}
  from '@fortawesome/pro-regular-svg-icons'

import {
  faDashboard as falDashboard,
  faEnvelope as falEnvelope,
  faLocationDot as falLocationDot,
  faUsers as falUsers,
  faAddressCard as falAddressCard,
  faNote as falNote,
  faHouseChimneyMedical as falHouseChimneyMedical,
}
  from '@fortawesome/pro-light-svg-icons'

import {
  faSort as fadSort,
}
  from '@fortawesome/pro-duotone-svg-icons'

import { faCcVisa, faCcAmex, faCcDinersClub, faCcDiscover, faCcMastercard, faCcJcb } from '@fortawesome/free-brands-svg-icons'

const createAbility = (abilities) => {
  return new PureAbility(abilities)
}

export async function mountVueApp({ componentName, targetId, path = 'components', plugins = [], afterMount }) {
  try {
    const target = document.getElementById(targetId)
    if (!target) return

    const props = JSON.parse(target.getAttribute('data'))
    const abilitiesJSON = target.getAttribute('data-abilities')
    const abilities = abilitiesJSON ? JSON.parse(abilitiesJSON) : []
    const provide = JSON.parse(target.getAttribute('data-provide'))
    const component = (await import(`../src/${path}/${componentName}.vue`)).default
    const app = createApp(component, props)
    plugins.forEach(plugin => app.use(plugin))

    app.use(abilitiesPlugin, createAbility(abilities), {
      useGlobalProperties: true,
    })

    if (provide) {
      Object.entries(provide).forEach(([key, value]) => {
        app.provide(key, value)
      })
    }

    app.mount(target)

    if (afterMount) {
      afterMount()
    }
  } catch (error) {
    logError(error, componentName)
  }
}

export function logError(error, componentName) {
  const e = new ErrorEvent('error', { message: `Error mounting Vue app for ${componentName}`, error: error })
  window.dispatchEvent(e)
  console.log(error)
}

export function loadAdminIcons() {
  library.add(
    faEnvelope, farEnvelope, falEnvelope,
    faArrowUpRight, farArrowUpRight,
    faArrowUpRightFromSquare, farArrowUpRightFromSquare,
    faPencil, farPencil,
    faDashboard, farDashboard, falDashboard,
    faCreditCard, farCreditCard,
    faFileInvoiceDollar, farFileInvoiceDollar,
    faMapLocation, farMapLocation,
    faChevronDown, farChevronDown,
    faChevronUp, farChevronUp,
    faInfoCircle, farInfoCircle,
    faFolderOpen, farFolderOpen,
    faTruck, farTruck,
    faBookOpen, farBookOpen,
    faEyeSlash, farEyeSlash,
    faCheck, farCheck,
    faUser, farUser,
    faTrash, farTrash,
    faDownload, farDownload,
    faLink, farLink,
    faPlus, farPlus,
    faPlusLarge, farPlusLarge,
    faList, farList,
    faRepeat, farRepeat,
    faPiggyBank, farPiggyBank,
    faBuilding, farBuilding,
    faBoxArchive, farBoxArchive,
    faEllipsisV, farEllipsisV,
    faComment, farComment,
    faLocationDot, farLocationDot, falLocationDot,
    faUsers, farUsers, falUsers,
    faAddressCard, farAddressCard, falAddressCard,
    faNote, farNote, falNote,
    faHouseChimneyMedical, farHouseChimneyMedical, falHouseChimneyMedical,
    faCrateApple, farCrateApple,
    faArrowLeft, farArrowLeft,
    faDolly, farDolly,
    faStarHalfAlt, farStarHalfAlt,
    faStar, farStar,
    faBoxOpen, farBoxOpen,
    faExclamationTriangle, farExclamationTriangle,
    faGear, farGear,
    farCircleCheck, faCircleCheck,
    faBullhorn, farBullhorn,
    faArrowUpToLine, farArrowUpToLine,
    farCircleXmark,
    faEdit, farEdit,
    faAdd, farAdd,
    faExclamationCircle, farExclamationCircle,
    faShelves, farShelves,
    faWrench, farWrench,
    faBalloon, farBalloon,
    faCoffee, farCoffee,
    faStore, farStore,
    faUtensils, farUtensils,
    faHandshake, farHandshake,
    faRecycle, farRecycle,
    faRecordVinyl, farRecordVinyl,
    faCloudArrowUp, farCloudArrowUp,
    faCirclePlus, farCirclePlus,
    faEye, farEye,
    faRotate, farRotate,
    faAward, farAward,
    faClose, farClose,
    faArchive, farArchive,
    faHatCowboy, farHatCowboy,
    faChartPieSimpleCircleDollar, farChartPieSimpleCircleDollar,
    faAppleCore,
    faBasketShopping, farBasketShopping,
    faGrid, farGrid,
    faLoader, farLoader,
    faLoader,
    faArrowRight, farArrowRight,
    faImage, farImage,
    faCircleExclamation, farCircleExclamation,
    faRobot, farRobot,
    faSwap, farSwap,
    faSpinner, farSpinner,
    faCalendarStar, farCalendarStar,
    faCalendarDay, farCalendarDay,
    faChevronLeft, farChevronLeft,
    faChevronRight, farChevronRight,
    faArrowUp, farArrowUp,
    faArrowDown, farArrowDown,
    faFaceSmileWink, farFaceSmileWink,
    faCircleQuestion, farCircleQuestion,
    faSort,
    faGalleryThumbnails, farGalleryThumbnails,
    faMapPin, farMapPin,
    faTag, farTag,
  )

  library.add(faCcVisa, faCcAmex, faCcDinersClub, faCcDiscover, faCcMastercard, faCcJcb)
}

export function loadClientIcons() {
  library.add(
    faCheck, farCheck,
    faArrowRight, farArrowRight,
    faArrowLeft, farArrowLeft,
    farArrowUpRightFromSquare, faArrowUpRightFromSquare,
    faArrowTrendUp, farArrowTrendUp,
    faArrowTrendDown, farArrowTrendDown,
    faArrowAltToBottom, farArrowAltToBottom,
    faChevronDown, farChevronDown,
    faChevronUp, farChevronUp,
    faHorizontalRule, farHorizontalRule,
    faImage, farImage,
    faSpinner, farSpinner,
    faMapLocation, farMapLocation,
    faArrowDownToLine, farArrowDownToLine,
    faArrowUp, farArrowUp,
    faArrowDown, farArrowDown,
    faRepeat, farRepeat,
    faMap, farMap,
    faPlus, farPlus,
    faInfoCircle, farInfoCircle,
    faIslandTropical,
    faLoader, farLoader,
    faBroomWide, farBroomWide,
    faPenToSquare, farPenToSquare,
    faTruck, farTruck,
    faMessageDots, farMessageDots,
    faRightToBracket, farRightToBracket,
    faMapPin, farMapPin,
    faHashtag, farHashtag,
    faCashRegister, farCashRegister,
    faCircleQuestion, farCircleQuestion,
    faReceipt, farReceipt,
    faShop, farShop,
    faClock, farClock,
    faChevronLeft, farChevronLeft,
    faChevronRight, farChevronRight,
    faX, farX,
    faMinus, farMinus,
    faTrash, farTrash,
    faCircleExclamation,
    faLocationDot, farLocationDot,
    faMapLocationDot, farMapLocationDot,
    faAngleDown, farAngleDown,
    faDownload, farDownload,
    faLink, farLink,
    faFaceSmile, farFaceSmile,
    faFaceLaugh, farFaceLaugh,
    faFaceFrown, farFaceFrown,
    faEmptySet, farEmptySet,
    faHourglassHalf, farHourglassHalf,
    faSearch, farSearch,
    faWheatSlash, farWheatSlash,
    faLeaf, farLeaf,
    faDropletSlash, farDropletSlash,
    faPeanuts, farPeanuts,
    faWineBottle, farWineBottle,
    faCircleK, farCircleK,
    faCarrot, farCarrot,
    faExclamationTriangle, farExclamationTriangle,
    faCalendarWeek, farCalendarWeek,
    faCalendarCircleExclamation, farCalendarCircleExclamation,
    faCalendarCirclePlus, farCalendarCirclePlus,
    faSquareQuestion, farSquareQuestion,
    faSwap, farSwap,
    faUser, farUser,
    faMoon, farMoon,
    farExclamationTriangle,
    farCommentPen,
    faShoppingCart, farShoppingCart,
    faCartShoppingFast, farCartShoppingFast,
    faCircleMinus, farCircleMinus,
    faSparkles, farSparkles,
    faGrid, farGrid,
    faFire,
    faPaperPlane, farPaperPlane,
    faEye, farEye,
    faEyeSlash, farEyeSlash,
    faEdit, farEdit,
    faPaperPlaneTop, farPaperPlaneTop,
    farFileLines, farFileExport,
    faFilter, farFilter,
    faPause, farPause,
    faStarExclamation, farStarExclamation,
    faSliders, farSliders,
    faRotateLeft, farRotateLeft,
    faBoxOpen, farBoxOpen,
    farDollar,
    farAppleWhole,
    farCrown,
    farCookie,
    farSnowflake,
    farFlowerTulip,
    farSun,
    farLeafMaple,
    faEnvelope, farEnvelope,
    faAddressCard, farAddressCard,
    faFileInvoiceDollar, farFileInvoiceDollar,
    faDashboard, farDashboard,
    faUsers, farUsers,
    faStarShooting,
    faMessageSmile, farMessageSmile,
    farClockRotateLeft,
    faPlay,
    faHome, farHome,
    fadSort,
    faDoNotEnter, farDoNotEnter,
    faHome, farHome,
    faStore, farStore,
    faAppleWhole, farAppleWhole,
    faChartBar, farChartBar,
    faCircleDollar, farCircleDollar,
    faFileInvoice, farFileInvoice,
    faClipboardCheck, farClipboardCheck,
    faCalendar, farCalendar,
    faGear, farGear,
    faSignOutAlt, farSignOutAlt,
    faTag, farTag,
    faSignInAlt, farSignInAlt,
    faBars, farBars,
  )
}
